import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';

export const collapseAnimation =
  trigger('collapse', [
    state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE, overflow: AUTO_STYLE, opacity: '1', paddingBottom: '{{paddingBottom}}'  }), {params: {paddingBottom: '16px'}}),
    state('true', style({ height: '0', visibility: 'hidden', overflow: 'hidden', opacity: '0', paddingBottom: '0' })),
    transition('false => true', animate('500ms cubic-bezier(0.45, 0, 0.55, 1)')),
    transition('true => false', animate('500ms cubic-bezier(0.45, 0, 0.55, 1)'))
  ]);
